import { render, staticRenderFns } from "./ItemAddressItem.vue?vue&type=template&id=c899fc22&scoped=true&"
import script from "./ItemAddressItem.vue?vue&type=script&lang=js&"
export * from "./ItemAddressItem.vue?vue&type=script&lang=js&"
import style0 from "./ItemAddressItem.vue?vue&type=style&index=0&id=c899fc22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c899fc22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c899fc22')) {
      api.createRecord('c899fc22', component.options)
    } else {
      api.reload('c899fc22', component.options)
    }
    module.hot.accept("./ItemAddressItem.vue?vue&type=template&id=c899fc22&scoped=true&", function () {
      api.rerender('c899fc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MobileViews/LocationDetails/ItemAddressItem.vue"
export default component.exports